"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: lifecycle/lifecycle-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Flifecycle%2Flifecycle-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleServiceClient = exports.GetOnboardingCustomerTypeResponse = exports.GetOnboardingCustomerTypeRequest = exports.UpdateOnboardingCustomerTypeResponse = exports.UpdateOnboardingCustomerTypeRequest = exports.DismissCtaResponse = exports.DismissCtaRequest = exports.AckCtaResponse = exports.AckCtaRequest = exports.RecordMilestoneReachedResponse = exports.RecordMilestoneReachedRequest = exports.GetMilestoneCtasResponse = exports.GetMilestoneCtasRequest = exports.GetCtasResponse = exports.GetCtasRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const lifecycle_customer_1 = require("./lifecycle-customer");
const lifecycle_milestone_1 = require("./lifecycle-milestone");
const protobufPackage = 'com.step.lifecycle.proto';
function createBaseGetCtasRequest() {
    return {};
}
exports.GetCtasRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetCtasRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetCtasRequest();
        return message;
    },
};
function createBaseGetCtasResponse() {
    return { cta: [] };
}
exports.GetCtasResponse = {
    fromJSON(object) {
        const message = {
            cta: globalThis.Array.isArray(object?.cta) ? object.cta.map((e) => lifecycle_milestone_1.Cta.fromJSON(e)) : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cta?.length) {
            obj.cta = message.cta.map((e) => lifecycle_milestone_1.Cta.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetCtasResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCtasResponse();
        message.cta = object.cta?.map((e) => lifecycle_milestone_1.Cta.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetMilestoneCtasRequest() {
    return { scope: lifecycle_milestone_1.MilestoneScope.INVALID_MILESTONE_SCOPE };
}
exports.GetMilestoneCtasRequest = {
    fromJSON(object) {
        const message = {
            scope: isSet(object.scope)
                ? (0, lifecycle_milestone_1.milestoneScopeFromJSON)(object.scope)
                : lifecycle_milestone_1.MilestoneScope.INVALID_MILESTONE_SCOPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.scope !== lifecycle_milestone_1.MilestoneScope.INVALID_MILESTONE_SCOPE) {
            obj.scope = (0, lifecycle_milestone_1.milestoneScopeToJSON)(message.scope);
        }
        return obj;
    },
    create(base) {
        return exports.GetMilestoneCtasRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetMilestoneCtasRequest();
        message.scope = object.scope ?? lifecycle_milestone_1.MilestoneScope.INVALID_MILESTONE_SCOPE;
        return message;
    },
};
function createBaseGetMilestoneCtasResponse() {
    return { milestoneCtas: [] };
}
exports.GetMilestoneCtasResponse = {
    fromJSON(object) {
        const message = {
            milestoneCtas: globalThis.Array.isArray(object?.milestoneCtas)
                ? object.milestoneCtas.map((e) => lifecycle_milestone_1.MilestoneCta.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.milestoneCtas?.length) {
            obj.milestoneCtas = message.milestoneCtas.map((e) => lifecycle_milestone_1.MilestoneCta.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetMilestoneCtasResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetMilestoneCtasResponse();
        message.milestoneCtas = object.milestoneCtas?.map((e) => lifecycle_milestone_1.MilestoneCta.fromPartial(e)) || [];
        return message;
    },
};
function createBaseRecordMilestoneReachedRequest() {
    return { type: lifecycle_milestone_1.MilestoneType.INVALID_MILESTONE_TYPE, referenceId: '' };
}
exports.RecordMilestoneReachedRequest = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? (0, lifecycle_milestone_1.milestoneTypeFromJSON)(object.type)
                : lifecycle_milestone_1.MilestoneType.INVALID_MILESTONE_TYPE,
        };
        if (isSet(object.referenceId)) {
            message.referenceId = globalThis.String(object.referenceId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== lifecycle_milestone_1.MilestoneType.INVALID_MILESTONE_TYPE) {
            obj.type = (0, lifecycle_milestone_1.milestoneTypeToJSON)(message.type);
        }
        if (message.referenceId !== undefined && message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        return obj;
    },
    create(base) {
        return exports.RecordMilestoneReachedRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecordMilestoneReachedRequest();
        message.type = object.type ?? lifecycle_milestone_1.MilestoneType.INVALID_MILESTONE_TYPE;
        message.referenceId = object.referenceId ?? '';
        return message;
    },
};
function createBaseRecordMilestoneReachedResponse() {
    return { cta: [] };
}
exports.RecordMilestoneReachedResponse = {
    fromJSON(object) {
        const message = {
            cta: globalThis.Array.isArray(object?.cta) ? object.cta.map((e) => lifecycle_milestone_1.Cta.fromJSON(e)) : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cta?.length) {
            obj.cta = message.cta.map((e) => lifecycle_milestone_1.Cta.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.RecordMilestoneReachedResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecordMilestoneReachedResponse();
        message.cta = object.cta?.map((e) => lifecycle_milestone_1.Cta.fromPartial(e)) || [];
        return message;
    },
};
function createBaseAckCtaRequest() {
    return { ctaId: '' };
}
exports.AckCtaRequest = {
    fromJSON(object) {
        const message = {
            ctaId: isSet(object.ctaId) ? globalThis.String(object.ctaId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ctaId !== '') {
            obj.ctaId = message.ctaId;
        }
        return obj;
    },
    create(base) {
        return exports.AckCtaRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAckCtaRequest();
        message.ctaId = object.ctaId ?? '';
        return message;
    },
};
function createBaseAckCtaResponse() {
    return {};
}
exports.AckCtaResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AckCtaResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAckCtaResponse();
        return message;
    },
};
function createBaseDismissCtaRequest() {
    return { ctaId: '' };
}
exports.DismissCtaRequest = {
    fromJSON(object) {
        const message = {
            ctaId: isSet(object.ctaId) ? globalThis.String(object.ctaId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ctaId !== '') {
            obj.ctaId = message.ctaId;
        }
        return obj;
    },
    create(base) {
        return exports.DismissCtaRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDismissCtaRequest();
        message.ctaId = object.ctaId ?? '';
        return message;
    },
};
function createBaseDismissCtaResponse() {
    return {};
}
exports.DismissCtaResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DismissCtaResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDismissCtaResponse();
        return message;
    },
};
function createBaseUpdateOnboardingCustomerTypeRequest() {
    return { customerType: lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE };
}
exports.UpdateOnboardingCustomerTypeRequest = {
    fromJSON(object) {
        const message = {
            customerType: isSet(object.customerType)
                ? (0, lifecycle_customer_1.customerTypeFromJSON)(object.customerType)
                : lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.customerType !== lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE) {
            obj.customerType = (0, lifecycle_customer_1.customerTypeToJSON)(message.customerType);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateOnboardingCustomerTypeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateOnboardingCustomerTypeRequest();
        message.customerType = object.customerType ?? lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE;
        return message;
    },
};
function createBaseUpdateOnboardingCustomerTypeResponse() {
    return { milestoneCtas: [] };
}
exports.UpdateOnboardingCustomerTypeResponse = {
    fromJSON(object) {
        const message = {
            milestoneCtas: globalThis.Array.isArray(object?.milestoneCtas)
                ? object.milestoneCtas.map((e) => lifecycle_milestone_1.MilestoneCta.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.milestoneCtas?.length) {
            obj.milestoneCtas = message.milestoneCtas.map((e) => lifecycle_milestone_1.MilestoneCta.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.UpdateOnboardingCustomerTypeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateOnboardingCustomerTypeResponse();
        message.milestoneCtas = object.milestoneCtas?.map((e) => lifecycle_milestone_1.MilestoneCta.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetOnboardingCustomerTypeRequest() {
    return {};
}
exports.GetOnboardingCustomerTypeRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetOnboardingCustomerTypeRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetOnboardingCustomerTypeRequest();
        return message;
    },
};
function createBaseGetOnboardingCustomerTypeResponse() {
    return { customerType: lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE };
}
exports.GetOnboardingCustomerTypeResponse = {
    fromJSON(object) {
        const message = {
            customerType: isSet(object.customerType)
                ? (0, lifecycle_customer_1.customerTypeFromJSON)(object.customerType)
                : lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.customerType !== lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE) {
            obj.customerType = (0, lifecycle_customer_1.customerTypeToJSON)(message.customerType);
        }
        return obj;
    },
    create(base) {
        return exports.GetOnboardingCustomerTypeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetOnboardingCustomerTypeResponse();
        message.customerType = object.customerType ?? lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE;
        return message;
    },
};
/**
 * Lifecycle Service API.
 *
 * Manages CTAs resulting upon users reaching certain milestones in their account lifecycle.
 */
class LifecycleServiceClient {
    rpc;
    name = 'com.step.lifecycle.proto.LifecycleService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/lifecycle';
    methods = [{
            name: 'GetCtas',
            requestType: exports.GetCtasRequest,
            responseType: exports.GetCtasResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetMilestoneCtas',
            requestType: exports.GetMilestoneCtasRequest,
            responseType: exports.GetMilestoneCtasResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'RecordMilestoneReached',
            requestType: exports.RecordMilestoneReachedRequest,
            responseType: exports.RecordMilestoneReachedResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'AckCta',
            requestType: exports.AckCtaRequest,
            responseType: exports.AckCtaResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'DismissCta',
            requestType: exports.DismissCtaRequest,
            responseType: exports.DismissCtaResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateOnboardingCustomerType',
            requestType: exports.UpdateOnboardingCustomerTypeRequest,
            responseType: exports.UpdateOnboardingCustomerTypeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetOnboardingCustomerType',
            requestType: exports.GetOnboardingCustomerTypeRequest,
            responseType: exports.GetOnboardingCustomerTypeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get user CTAs
     */
    getCtas(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * DEPRECATED: Use LifecycleServiceV2.GetCtas instead.
     * Get a user's Milestone/CTA pair by scope
     */
    getMilestoneCtas(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Record that a user reached a milestone.
     */
    recordMilestoneReached(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * DEPRECATED: Use LifecycleServiceV2.AckCtaV2 instead.
     * Acknowledges CTA
     */
    ackCta(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Dismisses CTA
     */
    dismissCta(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * DEPRECATED: Use LifecycleServiceV2.UpdateOnboardingCustomerType instead.
     * Update the customer type of the onboarding flow
     */
    updateOnboardingCustomerType(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get the customer type of the onboarding flow
     */
    getOnboardingCustomerType(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.LifecycleServiceClient = LifecycleServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=lifecycle-service.js.map